export default "__VITE_ASSET__CKz$ACGT__"